import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        margin: 10
    },
    gridTitle: {
        paddingTop: 30,
        paddingBottom: 20
    },
    gridLitrage: {
        marginTop: 15,
        marginBottom: 15
    },
    icon: {
        textAlign: 'left'
    }
}))
